import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListRegisterRequest extends IBaseRequest {
    moduleId?:string;
    key?:string;
    currentUser?:number;
    level?:number;
    application?:number;
}

export class ListRegisterRequest extends BaseRequest implements IListRegisterRequest {
    public moduleId?:string;
    public key?:string;
    public currentUser?:number;
    public level?:number;
    public application?:number;

    constructor(server: string, session: string, moduleId?:string, key?:string, currentUser?:number, level?:number, application?:number) {
        super(server, session);
        this.moduleId = moduleId;
        this.key = key;
        this.currentUser = currentUser;
        this.level = level;
        this.application = application;
    }

    public toXml(): string {
        var parameters: string = super.toXml();
        parameters += this.makeNode(this.moduleId, 'moduleId');
        parameters += this.makeNode(this.key, 'key');
        parameters += this.makeNode(this.currentUser, 'currentUser');
        parameters += this.makeNode(this.level, 'level');
        parameters += this.makeNode(this.application, 'application');
        return super.wrapperXml('ListRegister', parameters);
    }
}
